// Fonction qui masque/affiche les blocs d'options
function updateVariantOptions() {
    document.querySelectorAll('.variant-picker__option').forEach(option => {
        const values = option.querySelectorAll('.variant-picker__option-value');
        
        // Afficher seulement si plus d'une valeur (taille/couleur…)
        option.style.display = values.length > 1 ? 'block' : 'none';
    });
}

document.addEventListener('DOMContentLoaded', () => {
    // 1. Au chargement de la page
    updateVariantOptions();

    // 2. Quand Shopify recharge le bloc produit / variantes
    const target = document.querySelector('main') || document.body;

    const observer = new MutationObserver((mutationsList) => {
        let shouldUpdate = false;

        mutationsList.forEach(mutation => {
            mutation.addedNodes.forEach(node => {
                if (!(node instanceof HTMLElement)) return;

                // Si un bloc variante ou le picker est ré-injecté → on relance
                if (
                    node.matches('.variant-picker__option, variant-radios, variant-selects') ||
                    node.querySelector('.variant-picker__option, variant-radios, variant-selects')
                ) {
                    shouldUpdate = true;
                }
            });
        });

        if (shouldUpdate) {
            updateVariantOptions();
        }
    });

    observer.observe(target, { childList: true, subtree: true });
});


document.addEventListener("DOMContentLoaded", () => {
    highlightCurrentMenuLink();
});

function highlightCurrentMenuLink() {
    const currentUrl = window.location.pathname.replace(/\/$/, ""); // enlève '/' final
    const navLinks = document.querySelectorAll('a[href]');

    navLinks.forEach(link => {
        // Normalisation du href
        let linkUrl = link.getAttribute('href');

        if (!linkUrl || linkUrl.startsWith('#') || linkUrl.startsWith('javascript')) return;

        // Garder seulement le pathname
        linkUrl = new URL(link.href).pathname.replace(/\/$/, "");

        // Comparaison exacte
        if (linkUrl === currentUrl) {
            link.classList.add("current");
        }
    });
}


/* home nav */



if(document.body.classList.contains('home')){

const sections=document.querySelectorAll('.viewport .shopify-section');
const viewport = document.querySelector(".viewport");
const links= document.querySelectorAll('.home-nav-link')


    var nSlider=0
    window.nSlider=0
    var currentSlide;
    let lastIndex = -1;


const animate=()=>{

            sections[nSlider].querySelectorAll('.splide__slide.is-active.is-visible').forEach((slide,index)=>{

                //console.log(index)

             currentSlide = slide;

                    if(index==0){
                        //console.log(currentSlide)
                    const title = currentSlide.querySelector('h2');
                    const price = currentSlide.querySelector('.price');
                    document.querySelector('.home-nav-title').innerHTML=`${title?.textContent} - <span>${price?.textContent}</span>`
                    }

            })

            //

               const viewportRect = viewport.getBoundingClientRect();
    const viewportCenter = viewportRect.top + viewportRect.height / 2;

    let closestIndex = -1;
    let closestDistance = Infinity;

    sections.forEach((section, index) => {
        const rect = section.getBoundingClientRect();
        const sectionCenter = rect.top + rect.height / 2;

        const distance = Math.abs(sectionCenter - viewportCenter);

        if (distance < closestDistance) {
            closestDistance = distance;
            closestIndex = index;
        }
    });

    if(closestIndex>2){
        closestIndex=2
    }

    //console.log("index",closestIndex)

    // Si la section visible change
    if (closestIndex !== lastIndex) {
        lastIndex = closestIndex;
        nSlider=closestIndex
        window.nSlider=nSlider

        if(closestIndex==0){
            document.querySelector('.home-nav-text').innerHTML="Défile horizontalement pour découvrir tous les packs"
            document.querySelector('.home-nav-text').classList.remove('white')
        }else if (closestIndex==1){
            document.querySelector('.home-nav-text').innerHTML="Défile horizontalement pour découvrir tous les disques"
            document.querySelector('.home-nav-text').classList.add('white')
        }else if(closestIndex==2){
            document.querySelector('.home-nav-text').innerHTML="Défile horizontalement pour découvrir tout le merch"
            document.querySelector('.home-nav-text').classList.remove('white')
        }

    }

            // Enlever nav-active de tous les liens
        links.forEach(link => link.classList.remove("active-nav"));

        // Ajouter nav-active au lien correspondant
        links[closestIndex].classList.add("active-nav");



    const viewportTop = viewport.getBoundingClientRect().top;
    const sectionTop = sections[2].getBoundingClientRect().top;

    if (sectionTop < viewportTop) {
            document.querySelector('.home-nav').classList.add('off')
    }else{
            document.querySelector('.home-nav').classList.remove('off')
    }


            //
            window.requestAnimationFrame(animate)

            }


animate()



links.forEach((link,index)=>{

        link.addEventListener('click',()=>{
            
                viewport.scrollTo({
                top: sections[index].offsetTop,
                behavior: "smooth"
                });
        })

})



document.querySelector('.home-nav-title').addEventListener('click',()=>{
   location.href=currentSlide.querySelector('product-card').dataset.productUrl
})



  const arrowLeft  = document.querySelector('.arrow-left');
  const arrowRight = document.querySelector('.arrow-right');


  // 👉 clic flèche gauche = slider de la section visible va à gauche
  arrowLeft.addEventListener('click', () => {
      window.sliders[nSlider].go('<');
  });

  // 👉 clic flèche droite = slider de la section visible va à droite
  arrowRight.addEventListener('click', () => {
      window.sliders[nSlider].go('>');

  });

}
      if(!sessionStorage.getItem('intro')){
            document.querySelector('.preloader-logo').classList.remove('off')
        setTimeout(() => {
            document.querySelector('.preload').classList.add('off')
        }, 1500);

      sessionStorage.setItem('intro','true')
        }



